import { useSyncExternalStore } from 'react';

// Subscribe to both cross-tab (storage) and same-tab (custom) events
const subscribe = (callback) => {
  window.addEventListener('storage', callback);
  window.addEventListener('local-storage', callback);
  return () => {
    window.removeEventListener('storage', callback);
    window.removeEventListener('local-storage', callback);
  };
};

export const useLocalStorage = (key) => {
  return useSyncExternalStore(
    subscribe,
    () => localStorage.getItem(key),
    () => null // SSR snapshot
  );
};

// Use these everywhere instead of localStorage.setItem / removeItem
export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
  window.dispatchEvent(new Event('local-storage'));
};

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
  window.dispatchEvent(new Event('local-storage'));
};
